import { API_CLIENT } from "../api_call/service_instances";

import {
	GET_POI,
	GET_RESTAURANTS,
	GET_POI_TURISEM
} from "../url/urls_in_app.js";

/*
 * --------------------------------------------------------
 *  Contain all url and fuctions needed to make call to the application
 *  only for poi part
 * --------------------------------------------------------
 */

export default {
	getPoi(lng, point_of_the_day = 0) {
		return API_CLIENT(GET_POI + lng + "&point_of_the_day=" + point_of_the_day);
	},

	getPoiTurisem(poi_id, lng) {
		return API_CLIENT(GET_POI_TURISEM + poi_id + "&ln=" + lng);
	},

	getRestaurants() {
		return API_CLIENT(GET_RESTAURANTS);
	}
};
